export const FETCH_BANNER_BEGIN = "FETCH_BANNER_BEGIN";
export const FETCH_BANNER_SUCCESS = "FETCH_BANNER_SUCCESS";
export const FETCH_BANNER_ERROR = "FETCH_BANNER_ERROR";
